import React from 'react'
import { Skeleton, Box } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { AppTableSeeker } from "@components"
import {formatDate} from "@ui-seeker/utils";

import { useToast } from '@hooks'
import { isLoadingCommonFilters } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { dateColumn, skuColumn, countryColumn, retailerColumn, activeColumn } from './columns'
import { useDynamicAssortmentFilters } from "../@hooks";
import { DynamicAssortmentSitesWarnings, DynamicAssortmentTableDateTitle } from "./@components";


export default function DynamicAssortmentTable() {

    const { data, siteWarnings, lastUpdateDate } = useDynamicAssortmentFilters()
    const { showToast } = useToast()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        ...skuColumn(),
        ...retailerColumn(),
        dateColumn('startDate', 'Start Date'),
        dateColumn('endDate', 'End Date'),
        ...activeColumn()
    ]

    return <>
        { !!siteWarnings?.length && <DynamicAssortmentSitesWarnings warnings={siteWarnings} /> }
        <AppTableSeeker
            data={data}
            title={<DynamicAssortmentTableDateTitle lastUpdateDate={lastUpdateDate} />}
            columns={columns}
            options={{
                tableBodyHeight: '700',
                onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/custom-dash/dynamic-assort/excel`),
                viewColumns: false,
            }}
        />
    </>
}